// extracted by mini-css-extract-plugin
export var paragraphContainer = "styles-module--paragraphContainer--lkIeO";
export var imageWrapper = "styles-module--imageWrapper--14W_c";
export var imageCaption = "styles-module--imageCaption--1e4k5";
export var overflowImage = "styles-module--overflowImage--1hIYG";
export var image = "styles-module--image--3PEwn";
export var bullet = "styles-module--bullet--2LhJx";
export var ordered = "styles-module--ordered--1VOQ0";